import { render, staticRenderFns } from "./WaitingScreen.vue?vue&type=template&id=04d20ca4"
import script from "./WaitingScreen.vue?vue&type=script&lang=js"
export * from "./WaitingScreen.vue?vue&type=script&lang=js"
import style0 from "./WaitingScreen.vue?vue&type=style&index=0&id=04d20ca4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@corefy+vue2-vue-template-compiler@2.7.24_@vue+compiler-sfc@3.5.17_b_3cd151110130808e214f6f819bd7543a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports